//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import Q96F2K from "../../Content/Country/Q96F2K";
//Install
import M42V32 from "../../Content/Country/M42V32";
//Install
import Y477FT from "../../../Media/Image/020.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Şubeler : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik Taahhüt, Türkiye ve Azerbaycan’daki Şubeleri İle Her Bölgede Müşterilerine Yüksek Kaliteli Hizmetler Sunmaktadır."
        //Element
        let URL = "https://temaselektrik.com/subeler"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB i457do" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Şubeler"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Türkiye’den Azerbaycan’a, ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Enerjiyi"
                                        ),
                                        //Element
                                        " Biz Taşıyoruz."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Taahhüt Limited Şirketi, Türkiye ve Azerbaycan’daki Şubeleri İle Her Bölgede Müşterilerine Hızlı, Güvenilir ve Yüksek Kaliteli Hizmetler Sunmaktadır."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Kapsamlı Operasyon Ağımız Aracılığı İle; Kamu Kurumlarından - Sanayi Tesislerine, KOBİ’lerden Özel Projelere Kadar Tüm Müşterilerimize Yerinde ve Etkin",
                                        //Element
                                        React.createElement("br", {}),
                                        //element
                                        "Çözümler Sağlıyoruz."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Her Şubemiz, Temas Elektrik Taahhüt’ün Uzman Kadrosunu ve Yenilikçi Yaklaşımını Temsil Eder; Projelerinizin Her Aşamasında Kalite ve Güveni Garanti Eder."
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB e649gp" },
                                    //Element
                                    React.createElement("img", { alt: "Şubeler", title: "Şubeler", src: Y477FT, width: "636", height: "auto" })
                                )
                            )
                        )
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB d44n75" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement(M42V32, {})
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement(Q96F2K, {})
                            )
                        )
                    )
                )
            ),
            //Element
            React.createElement(Footer, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;